import { Injectable } from '@angular/core';
import { ApiService } from './api/api.service';
import { AuthService } from './auth.service';
import { EventBusService, EventType } from './event-bus.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { SignalRService } from './signalr.service';
import { MonitoringStatistics } from '../types/generated.types';
import { TenantsService } from './tenants.service';

@Injectable({ providedIn: 'root' })
export class MonitoringStatisticsService {
  private statisticsSubject = new BehaviorSubject<MonitoringStatistics>(null);

  get statistics$(): Observable<MonitoringStatistics> {
    return this.statisticsSubject.asObservable();
  }

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private tenantsService: TenantsService,
    eventBusService: EventBusService,
    signalRService: SignalRService,
  ) {
    eventBusService.on(EventType.OrganizationChanged).subscribe(() => void this.refresh());
    this.tenantsService.selectedTenantId$.subscribe(() => void this.refresh());
    signalRService.monitoringDataUpdated$.subscribe(() => void this.refresh());
    void this.refresh();
  }

  async refresh(): Promise<void> {
    if (!this.authService.isLoggedIn) {
      return;
    }

    try {
      const statistics = await this.apiService.monitoring.getStatistics(this.tenantsService.selectedTenantId);
      this.statisticsSubject.next(statistics);
    } catch {
      // ignored
    }
  }
}
